import angular from 'angular';

angular.module('cloudX').filter('ownCompanyName', ['dataCache', ownCompanyNameFilter]);

function ownCompanyNameFilter(dataCache) {
  return function(companyId) {
    if (!companyId || companyId === '00000000-0000-0000-0000-000000000000') return '';
    var company = dataCache.getObject('company')[companyId];
    if (!company) return '';
    return company.name;
  };
}
